module.exports = __webpack_public_path__ + "static/media/logo_white.64ac9519.svg";